import { Box, Button, Modal, Typography } from "@mui/material";
import { React } from "react";

const InactivityModal = ({ open, onDismiss, inactiveMinutes }) => {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return;
    onDismiss();
  };
  return (
    <Modal open={open} onClose={() => {}} disableEscapeKeyDown>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 4,
          boxShadow: 24,
          borderRadius: 2,
          textAlign: "center",
          width: 350,
        }}
      >
        <Typography variant="h6" gutterBottom>
          You've been inactive for {inactiveMinutes} minutes.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You will be logged out soon unless you interact with the page
        </Typography>
        <Button variant="contained" onClick={onDismiss}>
          I'm still here
        </Button>
      </Box>
    </Modal>
  );
};
export default InactivityModal;
